import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, onSnapshot, query, where, Timestamp } from 'firebase/firestore';
import { auth, db, COLLECTIONS } from '../utils/firebase';

/**
 * 담임이 연 `status == open` 생일 롤링페이퍼 중, 로그인 사용자(Auth uid) 대상 문서의 공개 토큰을 구독합니다.
 */
export function useActiveBirthdayRollingPaperId(): string | null {
  const [paperId, setPaperId] = useState<string | null>(null);

  useEffect(() => {
    let fireUnsub: (() => void) | undefined;

    const authUnsub = onAuthStateChanged(auth, (user) => {
      fireUnsub?.();
      fireUnsub = undefined;

      const uid = user?.uid;
      if (!uid) {
        setPaperId(null);
        return;
      }

      const q = query(
        collection(db, COLLECTIONS.BIRTHDAY_ROLLING_PAPERS),
        where('studentId', '==', uid),
        where('status', '==', 'open')
      );

      fireUnsub = onSnapshot(
        q,
        (snap) => {
          if (snap.empty) {
            setPaperId(null);
            return;
          }
          let bestId = snap.docs[0].id;
          let bestMs = -1;
          snap.docs.forEach((d) => {
            const ca = d.data().createdAt;
            let ms = -1;
            if (ca instanceof Timestamp) ms = ca.toMillis();
            else if (ca && typeof (ca as { toMillis?: () => number }).toMillis === 'function') {
              ms = (ca as { toMillis: () => number }).toMillis();
            }
            if (ms >= bestMs) {
              bestMs = ms;
              bestId = d.id;
            }
          });
          setPaperId(bestId);
        },
        (err) => {
          console.error('생일 롤링페이퍼 구독 오류:', err);
          setPaperId(null);
        }
      );
    });

    return () => {
      authUnsub();
      fireUnsub?.();
    };
  }, []);

  return paperId;
}
